"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./UserBalanceComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)(['user-balance']);
var UserBalanceComponent = function UserBalanceComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses(null, 'with-small-padding')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: "".concat(props.position1.ProductSymbol, " ").concat(t('Balance'), ":"),
    text: props.position1.Amount,
    customClass: bemClasses()
  })), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: "".concat(props.position2.ProductSymbol, " ").concat(t('Balance'), ":"),
    text: props.position2.Amount,
    customClass: bemClasses()
  }));
};
var _default = exports["default"] = UserBalanceComponent;